class Corde
{
    constructor()
    {
        this.init();
    }

    init()
	{
		gsap.from('.corde-haut', {
            scrollTrigger: {
                trigger: '.corde-haut',
                start: 'top 90%',
                end: 'top 40%',
                scrub: 2,
                markers: false
            },
            xPercent: 100
        });

        gsap.from('.corde-bas', {
            scrollTrigger: {
                trigger: '.corde-bas',
                start: 'top 90%',
                end: 'top 40%',
                scrub: 2,
                markers: false
            },
            xPercent: 100
        });
	}
}

export default Corde;